import { connect } from "react-redux";

import { deleteAllAnnotations } from "~/store/ducks/user/annotations";
import { showModal } from "~/store/ducks/domain/ui/modal";
import { selectDisplayedPages } from "~/store/selectors/page";
import { selectMaterialsByCategoryAndTabSorted } from "~/store/selectors/dls";
import { selectCurrentPageForActiveCategory } from "~/store/ducks/domain/ui/embedded";
import {
  showDeleteAllAnnotationsDialog,
  selectIsShowingDeleteAllAnnotationsDialog,
  hideDeleteAllAnnotationsDialog
} from "~/store/ducks/domain/ui/annotations";
import DeleteAllAnnotations from "./DeleteAllAnnotationsModal";

const mapStateToProps = state => {
  return {
    displayedPages: selectDisplayedPages(state),
    materials: selectMaterialsByCategoryAndTabSorted(state),
    currentMaterialPage: selectCurrentPageForActiveCategory(state)
  };
};

const mapDispatchToProps = {
  deleteAllAnnotations
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAllAnnotations);
